/**
 * Config: Classes
 * -----------------------------------------------------------------------------
 * Global configuration for Vue states and CSS classes.
 * - Add in alphabetical order.
 *
 */
export default {
  active: 'is-active',
  collapsed: 'is-collapsed',
  disabled: 'is-disabled',
  error: 'is-error',
  fixed: 'is-fixed',
  hidden: 'is-hidden',
  loading: 'is-loading',
  minimised: 'is-minimised',
  moved: 'is-moved',
  open: 'is-open',
  tabbable: 'is-tabbable',
  updating: 'is-updating',
  visible: 'is-visible',
  visuallyHidden: 'visually-hidden',
}
